import request from '../utils/request'

export default {
	/* 获取头部消息列表 */
	userNoticeList(params) {
		return request({
			url: '/user_notice/list',	
			method: 'get',
			data: params,
		})
	},
	/* mock已读所有信息 */
	readAllMessage(params) {
		return request({
			url: '/user_notice/all_read',
			method: 'post',
			data: params
		})
	},
	/* 获取平台下拉列表 */
	getSitePlatform(params) {
		return request({
			url: '/site/get_site_platform',
			method: 'get',
			data: params,
		})
	},
}
